import React from 'react';
import { Text, LegacyStack } from '@shopify/polaris';
import { measurementPoints } from '../../services/garmentTemplateService';
import { translateMeasurementPoints } from '../../services/translationsService';

/**
 * Component to display the measurement diagram for a specific garment type
 */
export default function MeasurementDiagram({ 
  garmentType = 'dress', 
  fontFamily = 'sans-serif',
  backgroundColor = '#f4f6f8',
  headingColor = '#212b36',
  textColor = '#637381',
  numberBgColor = '#0068d9',
  numberColor = '#ffffff',
  language = 'en',
  translatedMeasurementPoints = null
}) {
  // Get measurement points for the selected garment type, using translations if provided
  const points = translatedMeasurementPoints ? 
    translatedMeasurementPoints[garmentType] || [] : 
    translateMeasurementPoints(measurementPoints, language)[garmentType] || [];
  
  // Get image path (using PNG files for the diagrams)
  const imagePath = `/images/sizecharts/${garmentType}.png`;
  
  return (
    <div style={{ fontFamily, backgroundColor }}>
      <LegacyStack distribution="fill" wrap={false} spacing="loose">
        {/* Measurement Diagram */}
        <div style={{ position: 'relative', minWidth: '200px', textAlign: 'center', marginTop: '20px' }}>
          <img 
            src={imagePath} 
            alt={`${garmentType} measurement diagram`} 
            style={{ maxWidth: '100%', height: 'auto' }}
            onError={(e) => {
              // Fallback to a generic image if the specific one isn't found
              e.target.src = '/images/sizecharts/dress.png';
            }}
          />
        </div>
        
        {/* Measurement Instructions */}
        <div>
          {points.map((point, index) => (
            <div key={point.id} style={{ marginBottom: '16px' }}>
              <LegacyStack spacing="tight" alignment="center">
                <div style={{ 
                  width: '24px', 
                  height: '24px', 
                  borderRadius: '50%', 
                  backgroundColor: numberBgColor, 
                  color: numberColor,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '8px'
                }}>
                  {index + 1}
                </div>
                <Text variant="headingSm" style={{ color: headingColor }}>{point.label}</Text>
              </LegacyStack>
              <div style={{ marginLeft: '32px' }}>
                <Text variant="bodyMd" style={{ color: textColor }}>{point.description}</Text>
              </div>
            </div>
          ))}
        </div>
      </LegacyStack>
    </div>
  );
}
